import { ActionDropdownItem } from "./ActionDropdownItem"
import DropdownButton from "react-bootstrap/esm/DropdownButton"
import { IPageAction } from "../../../base/models"
import { MUIIcon } from "../../../widgets"

export const ActionDropdownButton = ({ action }: {
    action: IPageAction
}) => {
    const actions = action.actions || []

    return <DropdownButton
        id={action.actionId}
        title={
            <>
                {action.icon && <MUIIcon iconName={action.icon} className="me-1" />}
                <span>{action.name}</span>
            </>
        }
        size="sm" variant="secondary">
        {actions.map(action => (<ActionDropdownItem key={action.actionId} action={action} />))}
    </DropdownButton>
}